// Zustimmung zum vorzeitigen Erlöschen des Widerrufsrechts (Häkchen im Warenkorb, snippets/cart-summary.liquid).
// Hält das Häkchen als Warenkorb-Attribut fest, damit es beim Neuaufbau des Warenkorbs
// (Menge ändern, Drawer neu laden) erhalten bleibt. Ohne Skript greift trotzdem das
// Pflichtfeld: Das Formular geht nur mit gesetztem Häkchen zur Kasse.
(() => {
  const SCHLUESSEL = 'Zustimmung digitale Inhalte';

  document.addEventListener('change', (event) => {
    const feld = event.target;
    if (!(feld instanceof HTMLInputElement) || !feld.matches('[data-widerruf-zustimmung]')) return;

    for (const anderes of document.querySelectorAll('[data-widerruf-zustimmung]')) {
      if (anderes !== feld) anderes.checked = feld.checked;
    }

    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { [SCHLUESSEL]: feld.checked ? feld.value : '' } }),
    }).catch(() => {});
  });
})();
